<template>
  <div class="IntelligentLinkageComponents">
    <diffusionAnalysisPup />
    <intelligentSuggestPup />
  </div>
</template>

<script>
import diffusionAnalysisPup from "./components/diffusionAnalysis";
import intelligentSuggestPup from "./components/intelligentSuggest";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { diffusionAnalysisPup, intelligentSuggestPup },
  props: {},
  data() {
    //这里存放数据
    return {
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  unmounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped='scoped'>
.IntelligentLinkageComponents {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>